// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// import { getDatabase } from "firebase/database";
import { getDatabase, ref, set, push, child, onValue} from "firebase/database";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD756jM-Z9JANVYL0QrPeqYLl1aVVb4daA",
  authDomain: "joel-salazar.firebaseapp.com",
  databaseURL: "https://joel-salazar-default-rtdb.firebaseio.com",
  projectId: "joel-salazar",
  storageBucket: "joel-salazar.appspot.com",
  messagingSenderId: "654799520991",
  appId: "1:654799520991:web:4cba9c4995726173b6956a",
  measurementId: "G-KPMTW7B712"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Realtime Database and get a reference to the service
const database = getDatabase(app);

document.getElementById("contact-form").addEventListener("submit", (event) => {
  event.preventDefault();

  var name = document.getElementById("name").value;
  var email = document.getElementById("email").value;
  var subject = document.getElementById("subject").value;
  var message = document.getElementById("message").value;
  
  const newPostKey = push(child(ref(database), 'contacts')).key;

  set(ref(database, "contacts/" + newPostKey), {
    name: name,
    email: email,
    subject: subject,
    message: message
  });

  document.getElementById("contact-modal").style.display = "none";
  document.getElementById("submitting-modal").style.display = "flex";

});

document.getElementById("submitting-acknowledge").addEventListener("click", (event) => {
  document.getElementById("submitting-modal").style.display = "none";
  document.getElementById("contact-modal").style.display = "none";
})